import React from 'react';

import Tab from '../components/Tab';
import Dropdown from '../components/Dropdown';
import SurfaceInput from './Inputs/SurfaceInput';

const Surface = () => {
  return(
    <div className='vesta-dropdown-filter-container'>
      <Tab name='Surface' tab='surface' />

      <Dropdown title='Quelle surface recherchez-vous ?' tab='surface'>
        <SurfaceInput />
      </Dropdown>
    </div>
  )
};

export default Surface;
